import { useNewEditTemplateCollectionContext } from "../../../context/NewEditTemplateCollectionContext"
import { useNewEditCollectionSave } from "../../../hooks/useNewEditCollectionSave"

export const useChangesWithoutSaveModal = () => {
    const { showPrompt, cancelNavigation, confirmNavigation } = useNewEditTemplateCollectionContext()
    const { handleSaveTemplate, loadingTemplate } = useNewEditCollectionSave()
    //Se guardarán aquí los datos del cobro en caso de que se confirme y se espera que se guarde para cambiar de ruta
    const handleOpenCloseModal = async ({ save }) => {
        if (!save) return confirmNavigation()
        //Guardar la informacion de cobro
        await handleSaveTemplate()
        confirmNavigation()
    }

    return {
        showPrompt,
        loadingTemplate,
        cancelNavigation,
        confirmNavigation,
        handleOpenCloseModal
    }
}